import React, { Component } from "react";

import { Container, Row, Col, Table, Form, Badge } from "react-bootstrap";

import CommonDataTableLoading from '../components/CommonDataTableLoading';
import CommonRowId from '../components/CommonRowId';
import CommonButton from '../components/CommonButton';
import CommonButtonBadge from '../components/CommonButtonBadge';
import CommonDropdown from '../components/CommonDropdown';
import CommonPagination from '../components/CommonPagination';
import CommonRecordNotFound from '../components/CommonRecordsNotFound';

import * as fn from '../../library/function';
import * as util from '../../library/utilitys';

import * as Actions from '../actions/ActionCenter';

import { OptionsConstants as options } from '../../config/constants/OptionsConstants';

class DataTableEB03DataCourse extends Component {

    render() {

        let props = this.props;

        let { onSetEdit, onNavigate, onDropDownChange, onCheckDelete, onCheckDeleteAll, onPaginationChange } = props;

        let { Action, DataTable, Inputs, Deletes, Operation, Masterbase, UserCookie } = props;

        let rowId = fn.getRowIdStart(DataTable.pagination);

        let deleteChecked = 0;
        DataTable.rows.forEach(row => {
             if (!['1', '2', '3'].includes(row.course_status)) { deleteChecked++; }
        });
        
        return (
            <Container fluid className="data-table-container">

                <CommonDataTableLoading isLoading={Action.Loading.dataTable} />    

                    <Row>
                        <Col md={12}>
                            {DataTable?.rows?.length > 0 ? 
                                <Table 
                                        responsive 
                                        borderless 
                                        className={`table-advance table-responsive ${!Action.Loading.dataTable ? 'table-visible' : ''}`}
                                    >
                                    <thead>
                                        <tr>
                                            <th className="th-width-auto-max th-font-sm">รหัส-ชื่อหลักสูตร</th>
                                            <th className="th-width-350p th-font-sm">สถาบัน</th>
                                            <th className="th-td-align-center th-width-100p th-font-sm">EB-03</th>
                                            <th className="th-td-align-center th-width-150p th-font-sm">การอบรม</th>
                                            <th className="th-width-50p"></th>
                                            <th className="th-td-align-center th-width-50p">
                                                {deleteChecked > 0 && (
                                                    <Form.Check 
                                                        type="checkbox"
                                                        checked={Deletes.checkAll}
                                                        onChange={(e) => onCheckDeleteAll(e, fn.getCheckboxAllItem('deletes'))} 
                                                        className="checkbox-font-sm"
                                                    />
                                                )}
                                            </th>                                             
                                        </tr>
                                    </thead>    
                                    <tbody>
                                        {DataTable.rows.map((row, index) => {

                                            Object.keys(row).forEach(key => { row[key] = util.renderText(row[key]); });
                                            
                                            rowId++;

                                            let del = true;
                                            if (['1', '2', '3'].includes(row.course_status)) { del = false; }

                                            return (
                                                <React.Fragment key={`${rowId}-${row.id}`}>
                                                    <tr className={((rowId % 2) === 1) ? 'striped-row' : ''}>
                                                        <td className="text-truncate td-font-sm" title={`${row.official_course_code} - ${row.course_eb_02_name}`}>
                                                            <Badge bg="success" size="md" className="badge-size-sm me-2">{row.official_course_code}</Badge>
                                                            {row.course_eb_02_name}
                                                        </td>  
                                                        <td className="text-truncate td-font-sm" title={row.academy_name}>{row.academy_name}</td>
                                                        <td className="text-truncate td-font-sm th-td-align-center"> 
                                                            <CommonButton 
                                                                task="open-content"
                                                                rounded={true}
                                                                disabled={false}
                                                                inlineClass='btn-font-sm text-secondary'
                                                                callback={() => Actions.handlePrintEBPopup('eb03-print',row.id)} 
                                                                disabled={!['0', '1', '2'].includes(UserCookie.types)}
                                                            />                                                                                                                                                                                        
                                                        </td>                                                         
                                                        <td className="th-td-align-center">
                                                            <CommonDropdown
                                                                element="DataTable"
                                                                input={{id: 'course_status', value: row.course_status}}
                                                                option={{source: 'options', section: 'status', item: 'eb02_course_status'}}
                                                                size="sm"
                                                                callback={(e, element) => {
                                                                    onDropDownChange(e, element, {key: 'id', value: row.id})
                                                                }}
                                                                disabled={true}
                                                                // disabled={!['0', '1', '2'].includes(UserCookie.types)}
                                                            />                                                                                                               
                                                        </td>                                                                                                                  
                                                        <td className="th-td-align-center">
                                                            <CommonButton 
                                                                task="edit" 
                                                                rounded={false}
                                                                disabled={false}
                                                                inlineClass="btn-font-sm"
                                                                callback={(e) => onSetEdit(e, {id: row.id})} 
                                                            />
                                                        </td>
                                                        <td className="th-td-align-center">
                                                            {del && (
                                                                <Form.Check 
                                                                    type="checkbox"
                                                                    name="deletes"
                                                                    value={row.id}
                                                                    checked={Deletes.deletes.includes(row.id)}
                                                                    onChange={(e) => onCheckDelete(e)} 
                                                                    className="checkbox-font-sm"
                                                                />
                                                            )}
                                                        </td>                                                           
                                                    </tr>                                                  
                                                </React.Fragment>    
                                            )
                                        })}                                                                                    
                                    </tbody>                                
                                </Table>
                            :
                                <CommonRecordNotFound Action={Action} rows={DataTable.pagination.totalRows} />
                            }

                            {!Action.Loading.dataTable && (
                                <CommonPagination 
                                    Pagination={DataTable.pagination} 

                                    handlePagination={(paging) => onPaginationChange(paging)}
                                />
                            )}                               
                        </Col>
                    </Row>                                


            </Container>                            
                        
        );                
    }
}

export default DataTableEB03DataCourse;                    